import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "SidebarLightMode",
  class: "sidebar-area"
}
const _hoisted_2 = {
  id: "accordionExample",
  class: "layout-menu menu-vertical menu bg-menu-theme scroll-bar active hv-100"
}
const _hoisted_3 = { class: "menu-inner" }
const _hoisted_4 = { class: "menu-item" }
const _hoisted_5 = { class: "menu-item" }
const _hoisted_6 = { class: "menu-item" }
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = {
  href: "javascript:void(0);",
  class: "menu-link menu-toggle collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapse17",
  "aria-expanded": "false",
  "aria-controls": "collapse17"
}
const _hoisted_9 = {
  id: "collapse17",
  class: "menu-sub collapse",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_10 = { class: "menu-item" }
const _hoisted_11 = { class: "menu-item" }
const _hoisted_12 = { class: "menu-item" }


export default /*@__PURE__*/_defineComponent({
  __name: 'MainSidebar',
  setup(__props) {

const closeAllCollapses = () => {
  // Simply remove the 'show' class from all open menus
  const collapses = document.querySelectorAll('.menu-sub.collapse.show');
  collapses.forEach((collapse) => {
    collapse.classList.remove('show');
  });
  
  // Also reset the toggle buttons to collapsed state
  const toggles = document.querySelectorAll('.menu-toggle:not(.collapsed)');
  toggles.forEach((toggle) => {
    toggle.classList.add('collapsed');
    toggle.setAttribute('aria-expanded', 'false');
  });
};


return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "menu-inner-shadow" }, null, -1)),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "menu-link",
            onClick: closeAllCollapses
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vue_feather, {
                type: "grid",
                class: "menu-icon tf-icons"
              }),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "title" }, "Dashboard", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/receipt-list",
            class: "menu-link",
            onClick: closeAllCollapses
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vue_feather, {
                type: "clipboard",
                class: "menu-icon tf-icons"
              }),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "title" }, "Query Builder", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/user-list",
            class: "menu-link",
            onClick: closeAllCollapses
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vue_feather, {
                type: "user",
                class: "menu-icon tf-icons"
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "title" }, "Users", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", _hoisted_8, [
            _createVNode(_component_vue_feather, {
              type: "settings",
              class: "menu-icon tf-icons"
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title" }, "Settings", -1))
          ]),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/account-settings",
                class: "menu-link"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Agency Settings ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/account-token",
                class: "menu-link"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" API Key ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: "/faq",
            class: "menu-link",
            onClick: closeAllCollapses
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vue_feather, {
                type: "help-circle",
                class: "menu-icon tf-icons"
              }),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "title" }, "FAQ", -1))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})